(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/search-receivers.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/search-receivers.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.SearchReceivers = Marionette.View.extend({
    delayTimer: 0,
    template: function(data) {
      data = data || {};
      if (parseInt(svs.grassroots.data.searchQuery, 10)) {
        data.searchQuery = decodeURIComponent(svs.grassroots.data.searchQueryName) || '';
      } else {
        data.searchQuery = svs.grassroots.data.searchQuery &&
        svs.grassroots.data.searchQuery.length > 0 ?
            decodeURIComponent(svs.grassroots.data.searchQuery) :
            '';
      }
      return svs.grassroots.templates.search_receivers(data);
    },

    events: {
      'keyup .js-grassroots-search-field': 'delayFetchSearchSuggestions',
      'click button[type=reset]': 'clearSearch',
      submit: 'clearSearchSuggestions',
      'click a': 'copySearchQuery'
    },
    regions: {
      searchSuggestions: '.js-search-suggestions'
    },

    initialize: function() {
      this.searchSuggestionsCol = new Backbone.Collection();
    },
    onRender: function() {
      this.showChildView(
        'searchSuggestions',
        new svs.grassroots.views.SearchSuggestions({
          collection: this.searchSuggestionsCol
        })
      );
    },
    fetchSearchSuggestions: function(e) {
      var options = {
        method: 'GET',
        path: '/player/1/sponsorship/autocomplete'
      };
      var self = this;
      var searchString = e.currentTarget.value;
      if (searchString.length > 0 && e.which !== 13) {
        if (searchString && searchString.length > 0) {
          options.path =
            options.path +
            '?numResponses=5&search=' +
            encodeURIComponent(searchString);
          svs.core.jupiter.call(
            options,
            function(result) {
              self.searchSuggestionsCol.reset(_.map(
                result.data,
                function(model) {
                  model.searchPath =
                      svs.grassroots.data.baseUrl +
                      'sok?q=' +
                      encodeURIComponent(model.name);
                  model.searchQueryId = model.id;
                  model.searchQuery = model.name;
                  return new Backbone.Model(model);
                }
              ));
            },
            function(xhr, textStatus, errorThrown) {
              self.searchSuggestionsCol.reset();
              svs.grassroots_logger.info('Fetching search suggestions failed: ' + errorThrown);
            }
          );
        }
      } else {
        self.searchSuggestionsCol.reset();
      }
    },
    delayFetchSearchSuggestions: function(e) {
      clearTimeout(this.delayTimer);
      var that = this;
      this.delayTimer = setTimeout(function() {
        that.fetchSearchSuggestions(e);
      }, 150);
    },
    clearSearch: function() {
      this.searchSuggestionsCol.reset();
      $('.js-grassroots-search-field').attr('value', '');
    },
    clearSearchSuggestions: function() {
      this.searchSuggestionsCol.reset();
      return $('.js-grassroots-search-field').val().length > 0;
    },
    copySearchQuery: function(e) {
      $('.js-grassroots-search-field').val($(e.currentTarget).data().query);
    }
  });
})(Backbone, _, svs);


 })(window);